import React, { useMemo } from 'react';
import { FIELD_DELIMITER } from 'js/utils/string';
import BaseQuestionResponse from './BaseQuestionResponse';
import { Icon } from 'js/components';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

function MultiSelectQuestionResponse({ question, response }) {
  const { answers } = question;
  const sortedAnswers = useMemo(
    () => [...answers].sort((a, b) => (a.ordinal ?? 0) - (b.ordinal ?? 0)),
    [answers]
  );
  const selectedAnswers = useMemo(() => {
    if (response?.value == null) {
      return [];
    }

    const responses = new Set(response.value.split(FIELD_DELIMITER));
    return sortedAnswers.filter((a) => responses.has(a.value));
  }, [response?.value, sortedAnswers]);

  return (
    <BaseQuestionResponse question={question}>
      <div className="question-review-response-value">
        {selectedAnswers.length > 0 ? (
          <ul className="list-unstyled question-review-response-value-list">
            {selectedAnswers.map((a) => (
              <li key={a.id}>
                <Icon icon={faCheck} className="icon icon-left" fixedWidth />
                <span>{a.text}</span>
              </li>
            ))}
          </ul>
        ) : (
          <span className="text-no-response">No response</span>
        )}
      </div>
    </BaseQuestionResponse>
  );
}

export default MultiSelectQuestionResponse;
